import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 90%;
    min-height: 300px;

    @media only screen and (min-width: 600px) {
      min-height: 600px;
    }
  }
`
